/* Zabi Hair — winkelwagen-drawer interacties (AJAX + Section Rendering API). */

/* Dawn-compatibele custom-element-API: product-form.js (Dawn) zoekt
   document.querySelector('cart-drawer') en roept getSectionsToRender(),
   setActiveElement() en renderContents() aan. Zonder deze methods gooit
   elke productkaart-ATC een TypeError vóór de fetch (add doet dan niets). */
if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', class extends HTMLElement {
    getSectionsToRender() {
      var id = this.getAttribute('data-section-id');
      return id ? [{ id: id }] : [];
    }
    setActiveElement(el) { this.activeElement = el; }
    renderContents() {
      if (typeof this.zabiRenderContents === 'function') this.zabiRenderContents();
    }
  });
}

(function () {
  var drawer = document.querySelector('cart-drawer.zabi-drawer');
  if (!drawer) return;

  var sectionId = drawer.getAttribute('data-section-id');
  var reserveSecs = parseInt(drawer.getAttribute('data-reserve') || '300', 10);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var clockTimer = null;

  /* ---- openen / sluiten ---- */
  function show() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function open() {
    /* Toon de drawer direct (geen wachten op fetch); ververs op de achtergrond. */
    show();
    refresh();
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* Dawn product-form ATC: open direct + ververs op de achtergrond (geen dubbele delay) */
  drawer.zabiRenderContents = function () {
    show();
    refresh();
  };

  /* ---- header-cart-icoon binden ---- */
  document.querySelectorAll('.zabi-header__icon--cart').forEach(function (icon) {
    icon.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  /* ---- verse sectie-HTML inladen (compare-prijzen serverside) ---- */
  function swap(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('.zabi-drawer__panel');
    var live = drawer.querySelector('.zabi-drawer__panel');
    if (fresh && live) live.innerHTML = fresh.innerHTML;
    startClock();
    updateHeaderCount();
  }
  function refresh() {
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId);
    return fetch(url)
      .then(function (r) { return r.text(); })
      .then(swap)
      .catch(function () {});
  }

  function updateHeaderCount() {
    var countEl = drawer.querySelector('[data-count]');
    var n = countEl ? parseInt(countEl.textContent, 10) : null;
    if (n === null || isNaN(n)) return;
    document.querySelectorAll('.zabi-header__cart-count').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('zabi-header__cart-count--hidden', n === 0);
    });
  }

  /* ---- cart-mutatie met verse sectie-render ---- */
  function mutate(endpoint, body) {
    body.sections = sectionId;
    body.sections_url = window.location.pathname;
    return fetch(root + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections && data.sections[sectionId]) {
          swap(data.sections[sectionId]);
        } else {
          return refresh();
        }
      });
  }

  /* ---- gedelegeerde events ---- */
  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-overlay]') || e.target.closest('[data-close]')) {
      close();
      return;
    }
    var step = e.target.closest('[data-step]');
    if (step) {
      var li = step.closest('[data-item]');
      var q = parseInt(li.querySelector('[data-qty]').textContent, 10) || 0;
      var next = q + parseInt(step.getAttribute('data-step'), 10);
      if (next < 0) next = 0;
      mutate('cart/change.js', { id: li.getAttribute('data-key'), quantity: next });
      return;
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) {
      var li2 = rm.closest('[data-item]');
      mutate('cart/change.js', { id: li2.getAttribute('data-key'), quantity: 0 });
      return;
    }
    var add = e.target.closest('[data-xadd]');
    if (add) {
      add.disabled = true;
      mutate('cart/add.js', { items: [{ id: parseInt(add.getAttribute('data-variant'), 10), quantity: 1 }] })
        .finally(function () { add.disabled = false; });
      return;
    }
    var apply = e.target.closest('[data-discount-apply]');
    if (apply) {
      var input = drawer.querySelector('[data-discount-input]');
      var code = (input && input.value || '').trim();
      if (code) window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=/cart';
      return;
    }
    var prev = e.target.closest('[data-xprev]');
    var nextBtn = e.target.closest('[data-xnext]');
    if (prev || nextBtn) {
      var track = drawer.querySelector('[data-xtrack]');
      if (track) track.scrollBy({ left: (prev ? -1 : 1) * 162, behavior: 'smooth' });
      return;
    }
  });

  /* ---- reserverings-countdown ---- */
  function startClock() {
    if (clockTimer) clearInterval(clockTimer);
    var clock = drawer.querySelector('[data-reserve-clock]');
    if (!clock) return;
    /* Tijd-gebaseerd: eindtijd in localStorage zodat de countdown blijft doorlopen
       tussen openingen (geen reset bij openen). Na 0 opnieuw reserveSecs. */
    var KEY = 'zabiReserveEnd';
    function readEnd() {
      var v = 0;
      try { v = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) {}
      if (!v || v <= Date.now()) {
        v = Date.now() + reserveSecs * 1000;
        try { localStorage.setItem(KEY, String(v)); } catch (e) {}
      }
      return v;
    }
    var endTime = readEnd();
    var tick = function () {
      var remaining = Math.round((endTime - Date.now()) / 1000);
      if (remaining <= 0) {
        endTime = Date.now() + reserveSecs * 1000;
        try { localStorage.setItem(KEY, String(endTime)); } catch (e) {}
        remaining = reserveSecs;
      }
      var m = Math.floor(remaining / 60);
      var s = remaining % 60;
      clock.textContent = m + ':' + (s < 10 ? '0' + s : s);
    };
    tick();
    clockTimer = setInterval(tick, 1000);
  }

  startClock();

  /* ---- open drawer bij add-to-cart elders (optioneel via event) ---- */
  document.addEventListener('zabi:cart:open', open);
})();
